import { createAction, props } from '@ngrx/store';

export const loadMapsApi = createAction('[Credentials] Load MapsApi');

export const mapsApiLoaded = createAction('[Credentials] Maps API Loaded');

export const setMapsApiKey = createAction('[Credentials] Set Maps API Key', props<{ apiKey: string }>());
